import React from 'react';
import { Box, Divider, Stack, Typography } from '@mui/material';

export const FormSection = ({ title, children }: { title: string; children: React.ReactNode }) => (
  <Stack spacing={3}>
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
      <Typography component="h3" fontWeight="semibold">
        {title}
      </Typography>
      <Divider sx={{ flex: 1 }} />
    </Box>
    <Stack spacing={2}>{children}</Stack>
  </Stack>
);
